export default __webpack_public_path__ + "static/media/gps.8cb01766.png";